export const getFrozenShoulderDataJson = () => {
  return {
    // Grouped Sections (like Lab Report tests array)
    chiefComplaint: 
    {
      complaintSide: "Right",
      durationValue: "",
      durationUnit: "Months",
      natureOfPain: "Continuous",
      symptoms: "Improving",
      onset: "Gradual",
      injury: "No",
      typeOfInjury: "Fall",
      aggravatingFactor: "Any Movement of Shoulder Joint",
      relievingFactor: "Rest",
      nightPain: "Increased",
      sleepDisturbance: "No",
      notes: ""
    },
    pastHistory:
    {
      htn: "No",
      dm2: "No",
      hypothyroidism: "No",
      rxHistory: "",
      notes: ""
    },
    examination:
    {
      examSide: "Right",
      swelling: "No",
      muscleWasting: "No",
      neuroDeficit: "No",
      neuroDeficitType: "Motor",
      capsularPattern: "No",
      muscleTightness: "No",
      musclesInvolved: [],
      tendernessOn: [],
      rom:[
        {
          name: "flexion",
          displayName: "Flexion",
          normal: '180',
          left: '0',
          right: '0'
        },
        {   
          name: "extension",
          displayName: "Extension",
          normal: '60',
          left: '0',
          right: '0'
        },
        {
          name: "abduction",
          displayName: "Abduction",
          normal: '180',
          left: '0',
          right: '0'
        },
        {
          name: "adduction",
          displayName: "Adduction",
          normal: '50',
          left: '0',
          right: '0'
        },
        {
          name: "medialRotation",
          displayName: "Medial Rotation",
          normal: '90',
          left: '0',
          right: '0'
        },
        {
          name: "lateralRotation",
          displayName: "Lateral Rotation",
          normal: '90',
          left: '0',
          right: '0'
        }
      ],
      musclePower: "Decreased due to pain",
      gripPinch: "Strong",
      tone: "Normal",
      coordination: "Good",
      notes: ""
    },
    specialTests: {
      thumpDropTest: "Negative",
      painfulArcTest: "Negative",
      notes: ""
    },
    functionalAssessment: {
      adl: "Independent",
      difficulties: [],
      notes: ""
    },
    managementPlan: {
      modalities: [],
      exercisePlan: [],
      prognosis: ""
    },
    
  };
};